import React from 'react';
import { Popover } from '@bedrock/components';
import { CreditCards } from '@bedrock/icons-react';
import classNames from 'classnames/bind';
import { ChannelSupplierBankDto } from '#services/api';
import styles from './index.less';

const cx = classNames.bind(styles);

interface BankCardHoverPopoverProps {
  value: ChannelSupplierBankDto;
  children: React.ReactNode;
  /** 下拉打开时传 true，禁用 Popover 避免与 Select 下拉冲突 */
  disabled?: boolean;
}

const buildItems = (value: ChannelSupplierBankDto) => [
  {
    label: '银行账号',
    key: 'bank_account',
    value: value?.bank_account,
  },
  {
    label: '账户名称',
    key: 'bank_account_name',
    value: value?.bank_account_name,
  },
  {
    label: '支行名称',
    key: 'banks_and_branches',
    value: value?.bank_branch_name,
  },
  {
    label: '银行地址',
    key: 'bank_address',
    value: value?.bank_country_name + value?.bank_province + value?.bank_city,
  },
  {
    label: 'Swift Code',
    key: 'swift_code',
    value: value?.swift_code,
  },
];

const HoverCardContent = ({ value }: { value: ChannelSupplierBankDto }) => {
  const items = buildItems(value);
  return (
    <div className={cx('bank-card-hover-card__container')}>
      <div>
        <CreditCards />
      </div>
      <div className={cx('bank-card-hover-card__container__content')}>
        {items.map((item, index) => (
          <div className={cx('bank-card-hover-card__item')} key={index}>
            <div
              className={cx(
                item.key === 'bank_account'
                  ? 'black-bold-text'
                  : 'bank-card-hover-card__item-label',
              )}
            >
              {item.label}：
            </div>
            <div
              className={cx(
                item.key === 'bank_account'
                  ? 'black-bold-text'
                  : 'bank-card-hover-card__item-value',
              )}
            >
              {item.value}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

/**
 * 银行卡悬浮 Popover 包装组件。
 * value 存在时，hover children 展示银行卡详情；否则直接渲染 children。
 * disabled=true 时关闭 Popover（如 Select 下拉展开时传入，避免冲突）。
 */
const BankCardHoverPopover = ({ value, children, disabled }: BankCardHoverPopoverProps) => {
  if (!value?.bank_business_code) {
    return <>{children}</>;
  }
  return (
    <Popover content={<HoverCardContent value={value} />} disabled={disabled}>
      {children}
    </Popover>
  );
};

export { HoverCardContent, buildItems };
export default BankCardHoverPopover;
